import lightningBorderAnimationUtil from "utils/lightning-border-animation-util";
import GameiomRequestFreespin from "gameiom/states/gameiom-request-freespin";

export default class CGGameiomRequestFreespin extends GameiomRequestFreespin {

    public onEnter() {
        lightningBorderAnimationUtil.stop();
        super.onEnter();
    }
}
